
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import SettingsModel from "slotworks/model/settings/settings-model";
import AbstractButtonBehaviour from "slotworks/smart-button/behaviours/abstract-button-behaviour";
import StateMachine from "slotworks/state-machine/state-machine";

export default class FreespinButtonBehaviour extends AbstractButtonBehaviour {

    public static HIDDEN: boolean = false;

    public skipArea: PIXI.Sprite;

    public init() {
        try {
            Layers.SmartButton.setScene("freespins").execute();
            this.button = Layers.SmartButton.getFlexiButton("freespin");
        } catch (e) {
            if (e.name === "InvalidSceneError") {
                Layers.SmartButton.defaultScene().execute();
                this.button = Layers.SmartButton.getFlexiButton("spin");
            } else {
                throw (e);
            }
        }

        const valueText = Layers.SmartButton.getText("freespins_value");
        if (valueText) {
            const record = GameState.getCurrentGame().getCurrentRecord();
            if (record instanceof FreespinRecord) {
                valueText.text = (record.remainingFreespins - 1).toString();
            } else if (record instanceof SpinRecord) {
                valueText.text = (record.freespinsWon - 1).toString();
            }
        }

        if (this.button) {
            this.button.on(ButtonEvent.POINTER_DOWN, this.skip);

            if (FreespinButtonBehaviour.HIDDEN) {
                this.button.setVisible(false);
            }
        }

        this.skipArea = Layers.SmartButton.getSprite("skipArea");
        if (this.skipArea) {
            this.skipArea.interactive = true;
            this.skipArea.addListener(ButtonEvent.POINTER_DOWN.getEventString() as any, this.skip);
            document.addEventListener("keyup", this.onKeyUpListener);
        }
    }

    public destroy() {
        if (this.button) {
            this.button.off(ButtonEvent.POINTER_DOWN, this.skip);
        }

        if (this.skipArea) {
            this.skipArea.interactive = false;
            this.skipArea.removeListener(ButtonEvent.POINTER_DOWN.getEventString() as any, this.skip);
            document.removeEventListener("keyup", this.onKeyUpListener);
        }

        super.destroy();
    }

    private skip = () => {

        StateMachine.skip();
    }

    private onKeyUpListener = (event: any) => {
        if (SettingsModel.getSpaceToSpin()) {
            if (event.keyCode === 32) {
                this.skip();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/slotworks/smart-button/behaviours/freespin-button-behaviour.ts